const allRoutes = {
  login: '/login',
  dashboard: '/dashboard',
  // addCompany: (type) => `/manageCompany/${type}/add`,
  // editCompany: (type, id) => `/manageCompany/${type}/edit/${id}`,
}
export default allRoutes
